import React, { useState, useEffect } from "react";
import { PlusOutlined, CloseCircleFilled } from "@ant-design/icons";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  Input,
  Row,
  Typography,
  Popconfirm,
  Card,
  Select,
  Collapse,
  Form,
  Button,
  Space,
  Spin,
  Col,
  Divider,
  DatePicker,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import CustomButton from "../../../../../../components/custom/CustomButton";
import TopContent from "../../../../../../components/layouts/TopContent";
import cnt from "../../../../../../services/definedConstant";
import { BOM } from "../../../../../../services/definedMethod";
import definedApi from "../../../../../../services/definedApi";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;
const { monthList } = staticConfig;

const EditAddress = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const dispatch = useDispatch();
  const [countryData, setCountryData] = useState([]);
  const [countryIdData, setCountryIdData] = useState([]);
  const [addressTypeIdData, setAddressTypeIdData] = useState([]);
  const [stateProvinceIdData, setStateProvinceIdData] = useState([]);
  const [addressDetail, setAddressDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTemplate();
    getDetailById();
  }, []);

  function getTemplate() {
    const url = `${apiConfig.Client}/addresses/template`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;

        let tempCountries = [];
        let tempCountryId = [];
        let tempAddressTypeId = [];
        let tempStateProvinceId = [];

        // console.log(objList);
        // return;

        objList?.countryOptions?.forEach((element) => {
          tempCountries.push({
            value: element.description,
            label: element.name,
          });
        });

        objList.countryIdOptions.forEach((element) => {
          tempCountryId.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.stateProvinceIdOptions.forEach((element) => {
          tempStateProvinceId.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.addressTypeIdOptions.forEach((element) => {
          tempAddressTypeId.push({
            value: element.id,
            label: element.name,
          });
        });

        setCountryData(tempCountries);
        setCountryIdData(tempCountryId);
        setAddressTypeIdData(tempAddressTypeId);
        setStateProvinceIdData(tempStateProvinceId);

        setIsLoading(false);
      }
    });
  }

  function getDetailById() {
    const url = `${apiConfig.Client}/${state.id}/addresses?type=${state.addressTypeId}`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        setAddressDetail(objList);

        // console.log(objList);
        // return;
        let objDetail = objList.find(
          (item) => item.addressId === state.addressId
        );

        // console.log(objDetail);

        // SHOW THE SAVED DATA
        useForm.setFieldsValue({
          addressLine1: objDetail?.addressLine1,
          addressLine2: objDetail?.addressLine2,
          city: objDetail?.city,
          postalCode: objDetail?.postalCode,
          stateProvinceId: objDetail?.stateProvinceId,
          countryId: objDetail?.countryId,
          addressId: objDetail?.addressId,
        });

        setIsLoading(false);
      }
    });
  }

  function onCancel() {
    navigate("/detail-customer", { state: state });
  }

  const onSubmit = (formValues) => {
    formValues.addressId = state.addressId;
    // console.log(formValues);
    // return;

    const url = `${apiConfig.Client}/${state.id}/addresses`;

    const body = {
      ...formValues,
      locale: "en",
      method: "PUT",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.editAddressMsg);
          delete state.addressId;
          delete state.addressTypeId;
          navigate("/detail-customer", { state });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-customer", { state });
          setIsLoading(false);
        },
      }
      );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.editAddress}
        pageItems={staticConfig.editAddressBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              active: false,
              isStaff: false,
            }}
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.addressSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressOne}
                  name={"addressLine1"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.addressOne),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.addressOne
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressTwo}
                  name={"addressLine2"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.addressTwo),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.addressTwo
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.country}
                  name={"countryId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.country),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.country,
                      "select"
                    )}
                    options={countryIdData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.stateProvince}
                  name={"stateProvinceId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.stateProvince),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.stateProvince,
                      "select"
                    )}
                    options={stateProvinceIdData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.city}
                  name={"city"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.city),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.city)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.postalCode}
                  name={"postalCode"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.postalCode),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.postalCode
                    )}
                  />
                </Form.Item>
              </Col>
              {/* <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.latitude}
                  name={"latitude"}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(labelConfig.latitude),
                  //   },
                  // ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.latitude)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.longitude}
                  name={"longitude"}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(labelConfig.longitude),
                  //   },
                  // ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.longitude
                    )}
                  />
                </Form.Item>
              </Col> */}
            </Row>
            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_ADDRESS") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(EditAddress);
